<!--
 * @Description: 
 * @Date: 2020-09-24 20:03:35
-->
<template>
  <div class="collection" @touchmove="preLoad($event)">
    <tab v-model="tabActive" :tabs="['收藏的文章', '收藏的视频']"></tab>
    <list v-bind="$data" :defaultMid="true">
      <div class="collection-content">
        <listItem v-for="(item,index) in listData" :key="index" :item="item" :type="item.type || 4">
          <template #footer>
            <div class="line" v-if="index != listData.length - 1"></div>
          </template>
        </listItem>
      </div>
    </list>
  </div>
</template>

<script>
import { getUserCollectList } from '@/api/ajax';
import { loadMore } from '@/mixins/loadMore';
import tab from '@/components/tab';
import list from '@/components/list/defaultList.vue';
import listItem from '@/components/list/listItem';
export default {
  mixins: [loadMore],
  data() {
    return {
      tabActive: 0,
      listAjax: getUserCollectList
    };
  },
  components: { tab, list, listItem },
  watch: {
    tabActive: {
      immediate: true,
      handler(v) {
        this.pageObj.collectType = v + 1;
        this.getList({ init: true });
      }
    }
  },
  computed: {
    type() {
      return;
    }
  },
  methods: {},
  created() {}
};
</script>

<style scoped lang='less'>
.collection {
  padding: 0.32rem;
  /deep/ &-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: .2rem;
  }
}
</style>
